import React from 'react';
import { isIosApp } from '../../../Utilities';

const BottomNavSpacer = (props) => {
  return (
    <div className='bottomNavSpacer' style={{ height: isIosApp ? '120px' : '80px' }}>
      <br />
      <br />
    </div>
  );
};

export default BottomNavSpacer;
